import { FC, useEffect, useState } from 'react';
import { Select } from 'antd';

type Props = {
  value: string;
  placeholder?: string;
  options: any[];
};

export const SelectDisabledMode: FC<Props> = ({
  value,
  options,
  placeholder = 'Select an option',
}) => {
  const [defaultValue, setDefaultValue] = useState(value);

  useEffect(() => {
    setDefaultValue(value);
  }, [value]);

  return (
    <Select
      value={defaultValue}
      placeholder={placeholder}
      disabled
      onSelect={(value) => setDefaultValue(value)}
      options={options}
      style={{ width: 'fit-content', minWidth: 250, maxWidth: '100%' }}
    />
  );
};
